import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, combineLatest, of } from 'rxjs';
import { take, map } from 'rxjs/operators';

import { snapshot } from '@fcom/rx';
import { AppState } from '@fcom/core';
import { hasOrderData, orderData } from '@fcom/common-booking';
import { FinnairOrder } from '@fcom/dapi/api/models';

import { StateActions, getStage } from '../../../store';
import { MmbStage } from '../../../enums';
import { canViewTravelPreparations } from '../../../utils/routing.utils';

@Injectable()
export class TravelPreparationsGuard implements CanActivate {
  constructor(private store$: Store<AppState>) {}

  private redirectToLogin(): boolean {
    this.store$.dispatch(StateActions.setStage({ stage: MmbStage.LOGIN }));
    return false;
  }

  canActivate(): Observable<boolean> {
    if (!snapshot(this.store$.pipe(hasOrderData()))) {
      return of(this.redirectToLogin());
    }

    return combineLatest([this.store$.pipe(orderData()), this.store$.pipe(getStage())]).pipe(
      take(1),
      map(([orderData, stage]: [FinnairOrder, MmbStage]) => {
        if (canViewTravelPreparations(orderData)) {
          if (stage !== MmbStage.TRAVEL_PREPARATION) {
            this.store$.dispatch(StateActions.setStage({ stage: MmbStage.TRAVEL_PREPARATION }));
          }
          return true;
        }
        return this.redirectToLogin();
      })
    );
  }
}
